import { Col, Divider, Row } from 'antd';
import { memo, ReactNode } from 'react';

interface IBoardContentItemChildren {
  content: {
    title: string | ReactNode;
    content: string | number | ReactNode;
    isShow?: boolean;
  }[];
}

export interface IBoardContentItem {
  title: string;
  children: IBoardContentItemChildren[];
  index?: number;
}

interface IBoardInfo {
  data: IBoardContentItem[];
}

export const BoardInfo = memo(({ data }: IBoardInfo) => {
  return (
    <>
      <Row gutter={[0, 8]} className="mt-[30px]">
        {data.map((item, index: number) => {
          return (
            <Col span={24} key={index}>
              {item.children.length > 0 ? (
                <>
                  {item.title && (
                    <Row>
                      <Col>
                        <p className="text-[#000000] font-bold text-xl">
                          {item?.index ?? index + 1}. {item?.title}
                        </p>
                      </Col>
                    </Row>
                  )}
                  <Row className={`pl-[28px] ${item.title && 'pt-[12px]'}`}>
                    {item.children.map((item, index: number) => {
                      const titles = item.content.map((item) => item.title);
                      const contents = item.content.map((item) => item.content);

                      return (
                        <Col key={index} span={12}>
                          <Row gutter={[5, 0]}>
                            <Col>
                              {titles.map((title, index: number) => (
                                <Row
                                  key={index}
                                  className={
                                    index > 0 ? 'mt-[4px] min-h-[22px]' : ''
                                  }
                                >
                                  {typeof title === 'string'
                                    ? title && (
                                        <p className="text-sm leading-[22px]">
                                          {title}
                                        </p>
                                      )
                                    : title}
                                </Row>
                              ))}
                            </Col>
                            <Col>
                              {contents.map((content, index: number) => (
                                <Row
                                  key={index}
                                  className={`${index > 0 ? 'mt-[4px]' : ''} min-h-[22px]`}
                                >
                                  <span className="font-semibold text-sm leading-[22px] mr-4">
                                    :
                                  </span>
                                  {typeof content === 'string' ||
                                  typeof content === 'number' ||
                                  content === null ? (
                                    <p className="font-semibold text-sm leading-[22px] min-h-[22px]">
                                      {titles[index]
                                        ? !content
                                          ? '-'
                                          : ` ${content}`
                                        : ''}
                                    </p>
                                  ) : (
                                    content
                                  )}
                                </Row>
                              ))}
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                  </Row>
                </>
              ) : (
                <Divider
                  dashed
                  className="mx-[28px] my-0 w-auto min-w-max border"
                />
              )}
            </Col>
          );
        })}
      </Row>
    </>
  );
});
